var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('Sec1'),_c('Sec2',{staticStyle:{"margin-top":"6rem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }